import {GenPole} from '../../../../../generated/serverModels/GenPole';

export class UASPole extends GenPole {
    constructor(pole?: UASPole) {
        super(pole);
    }
}
